export enum ReservationType {
    HDD = 'HDD',
    HDP = 'HDP',
    ASISTENT = 'ASISTENT',
    WIDGET = 'WIDGET',
    EA = 'EA',
    WIDGET_VOUCHER = 'WIDGET_VOUCHER',
    G100_WIDGET = 'G100_WIDGET',
}
